import { Phone, CheckCircle } from 'lucide-react';
import { Accordion, AccordionContent, AccordionItem, AccordionTrigger } from '../../components/ui/accordion';
import '../ServicePage.css';

const BackNeckService = () => {
  const whatsappUrl = 'https://wa.me/919886332528';
  const conditions = ['Chronic back pain', 'Acute neck pain', 'Lumbar spondylosis', 'Cervical spondylitis', 'Herniated disc (PIVD)', 'Sciatica', 'Postural pain', 'Facet joint dysfunction'];
  const equipment = ['Traction units', 'TENS/IFT therapy', 'Ultrasound therapy', 'Laser therapy', 'Postural correction exercises'];

  return (
    <div className="service-page">
      <div className="service-hero">
        <div className="container">
          <h1>Back & Neck Pain Treatment</h1>
          <p className="service-subtitle">Effective treatment for chronic and acute back and neck pain</p>
        </div>
      </div>

      <section className="section">
        <div className="container service-container">
          <div className="service-content">
            <h2>What is Back & Neck Pain Treatment?</h2>
            <p>Back and neck pain are among the most common reasons people seek physiotherapy. Our specialized treatment addresses the root cause of pain, provides relief, and prevents recurrence through strengthening and postural correction.</p>

            <h2>Conditions We Treat</h2>
            <ul className="conditions-list">
              {conditions.map((condition, index) => (
                <li key={index}><CheckCircle size={20} /><span>{condition}</span></li>
              ))}
            </ul>

            <h2>What to Expect at Our Clinic</h2>
            <p>We perform detailed assessments including posture analysis, movement testing, and pain pattern evaluation. Treatment combines manual therapy, therapeutic exercises, traction, and advanced equipment for comprehensive pain relief.</p>

            <h2>Equipment Used</h2>
            <div className="equipment-tags">
              {equipment.map((item, index) => (<span key={index} className="equipment-tag">{item}</span>))}
            </div>

            <div className="service-cta">
              <a href={whatsappUrl} target="_blank" rel="noopener noreferrer" className="btn-primary">
                <Phone size={20} />Book Appointment on WhatsApp
              </a>
            </div>

            <h2>Frequently Asked Questions</h2>
            <Accordion type="single" collapsible className="service-faq">
              <AccordionItem value="item-1">
                <AccordionTrigger>Can physiotherapy cure chronic back pain?</AccordionTrigger>
                <AccordionContent>While "cure" depends on the underlying cause, physiotherapy is highly effective in managing and significantly reducing chronic back pain. Many patients achieve complete pain relief with proper treatment.</AccordionContent>
              </AccordionItem>
              <AccordionItem value="item-2">
                <AccordionTrigger>Is bed rest good for back pain?</AccordionTrigger>
                <AccordionContent>Prolonged bed rest is actually not recommended for back pain. Gentle movement and appropriate exercises, guided by a physiotherapist, promote faster recovery.</AccordionContent>
              </AccordionItem>
              <AccordionItem value="item-3">
                <AccordionTrigger>Will I need surgery for my disc problem?</AccordionTrigger>
                <AccordionContent>Most disc problems can be successfully treated with physiotherapy without surgery. We'll assess your condition and work to help you avoid surgery when possible.</AccordionContent>
              </AccordionItem>
              <AccordionItem value="item-4">
                <AccordionTrigger>How can I prevent back pain from returning?</AccordionTrigger>
                <AccordionContent>We teach you proper posture, ergonomics, and exercises to strengthen your back and core muscles. Regular exercise and maintaining good habits significantly reduce recurrence.</AccordionContent>
              </AccordionItem>
            </Accordion>
          </div>
        </div>
      </section>
    </div>
  );
};

export default BackNeckService;